import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../../components/atoms";
import { RegisterListItem } from "./components";

const RegisterDisplay = ({ height, validatedUserArray, setloading }) => {
  const [displayArrayUsers, setDisplayArrayUsers] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(false);

  const itemProductGraphCreate = ({ userId, userName, item }) => {
    let stock = 0;

    let promotionCheck = [];

    let price = [];

    let productTotal = [];
    let productList = [];
    let qtyArray = [];

    // console.log("date", date);
    // console.log("userName", userName);

    for (let i = 0; i < validatedUserArray.receiptList.length; i++) {
      const elementItem = validatedUserArray.receiptList[i];
      //   console.log("elementItem", elementItem);

      if (userId === elementItem.customerUserId) {
        //   userName = element.firstName + " " + element.lastName;
        productList.push({
          dataItem: elementItem,
          userName: userName,
        });
        productTotal.push(Number(elementItem.total));
        qtyArray.push({
          promotions: elementItem.promotions,
          slipNo: elementItem.slipNo,
        });
      }
    }

    let productTotalAmount = productTotal.reduce(function (x, y) {
      return x + y;
    }, 0);
    // let quantityAccount = qtyArray.reduce(function (x, y) {
    //   return x + y;
    // }, 0);

    // console.log("check productTotal", productTotal);
    // console.log("check productTotalAmount", productTotalAmount);
    // console.log("check qtyArray", qtyArray);
    // console.log("check productList", productList);

    return {
      recieptArray: productList,
      userName: userName,
      noOfPurchases: productTotal.length,
      purchaseTotal: productTotalAmount,
      customerInfo: item,
    };
  };

  const userDisplayArrayData = () => {
    setloading(true);
    let arrayAmount = [];
    let completeArray = [];
    let dateArrayCheck = [];
    let abrArray = [];
    if (validatedUserArray && validatedUserArray.allValidatedUsers) {
      for (
        let index = 0;
        index < validatedUserArray.allValidatedUsers.length;
        index++
      ) {
        const element = validatedUserArray.allValidatedUsers[index];

        arrayAmount.push(
          Number(
            itemProductGraphCreate({
              userId: element._id,
              userName: element.firstName + " " + element.lastName,
              item: element,
            }).purchaseTotal
          )
        );
        dateArrayCheck.push(
          itemProductGraphCreate({
            userId: element._id,
            userName: element.firstName + " " + element.lastName,
            item: element,
          }).userName
        );
        abrArray.push(
          itemProductGraphCreate({
            userId: element._id,
            userName: element.firstName + " " + element.lastName,
            item: element,
          }).noOfPurchases
        );
        completeArray.push(
          itemProductGraphCreate({
            userId: element._id,
            userName: element.firstName + " " + element.lastName,
            item: element,
          })
        );
      }
    }

    setDisplayArrayUsers(completeArray);
    setloading(false);
    return {
      arrayAmount: arrayAmount,
      dateArray: dateArrayCheck,
      completeArray: completeArray,
      abrArray: abrArray,
    };
  };

  let getCount = () => {
    let count = [];
    if (displayArrayUsers) {
      for (let index = 0; index < displayArrayUsers.length; index++) {
        const element = displayArrayUsers[index];
        if (element.purchaseTotal >= 1) {
          count.push(element);
        }
      }
    }
    return count.length;
  };
  let getCountValue = () => {
    let count = [];
    if (displayArrayUsers) {
      for (let index = 0; index < displayArrayUsers.length; index++) {
        const element = displayArrayUsers[index];
        if (element.purchaseTotal >= 1) {
          count.push(element.purchaseTotal);
        }
      }
    }
    let saleTotalAmount = count.reduce(function (x, y) {
      return x + y;
    }, 0);
    return Number(saleTotalAmount).toFixed(2);
  };

  //   let getCountRecieptDate = ({ recieptArray, reciptCount }) => {
  //     let count = [...recieptArray];

  //     let checkDataItem = count[reciptCount].dataItem.dateTime;

  //     if (reciptCount && recieptArray) {
  //       return checkDataItem;
  //     } else {
  //       return 0;
  //     }
  //   };
  const sortArray = displayArrayUsers
    ? displayArrayUsers.sort(function (a, b) {
        return b.purchaseTotal - a.purchaseTotal;
      })
    : null;
  useEffect(() => {
    if (validatedUserArray) {
      userDisplayArrayData();
      // here is where the approval fileds will be added for review
    }
  }, [validatedUserArray]);

  return (
    <div
      style={{
        // minHeight: 800,
        // maxHeight: 800,
        flex: 1,
        display: "flex",
        justifyContent: "flex-start",
        overflowY: "scroll",
        overflowX: "hidden",
        flexDirection: "column",
        scrollbarWidth: "none",

        maxHeight: height - 180,
      }}
    >
      <div
        style={{
          width: "100%",
          minHeight: 60,
          backgroundColor: "#00000030",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ marginLeft: 10 }}>
          <div style={{ display: "flex", fontSize: 10, fontWeight: "bold" }}>
            CUSTOMER COUNT :
          </div>
          <div>{displayArrayUsers ? getCount() : "loading"}</div>
        </div>

        <div style={{ flex: 1 }}></div>
        <div style={{ marginRight: 10 }}>
          <div style={{ display: "flex", fontSize: 10, fontWeight: "bold" }}>
            SALES COUNT:
          </div>
          <div>
            {displayArrayUsers && validatedUserArray
              ? validatedUserArray.receiptList.length
              : "loading"}
          </div>
        </div>
        <div style={{ marginRight: 10 }}>
          <div style={{ display: "flex", fontSize: 10, fontWeight: "bold" }}>
            AVERAGE SALE:
          </div>
          <div>
            {displayArrayUsers && validatedUserArray
              ? "R " +
                (
                  getCountValue() / validatedUserArray.receiptList.length
                ).toFixed(2)
              : "loading"}
          </div>
        </div>
        <div style={{ marginRight: 10 }}>
          <div style={{ display: "flex", fontSize: 10, fontWeight: "bold" }}>
            SALES MADE:
          </div>
          <div>
            {displayArrayUsers && validatedUserArray
              ? "R " + getCountValue()
              : "loading"}
          </div>
        </div>
      </div>
      {displayArrayUsers
        ? sortArray.map((item, index) => {
            return item.purchaseTotal >= 1 ? (
              <div style={{ width: "100%" }} key={index}>
                <RegisterListItem
                  item={item}
                  setSelectedIndex={setSelectedIndex}
                  selectedIndex={selectedIndex}
                  index={index}
                />
              </div>
            ) : null;
          })
        : null}
    </div>
  );
};

export default RegisterDisplay;
